export default "__VITE_ASSET__Ce8jY8oU__"